import React from "react";
import PropTypes from "prop-types";
import NewPlanCheckout from "./NewPlanCheckout";
import ChangePlanCheckout from "./ChangePlanCheckout";
import CurrentPlanCheckout from "./CurrentPlanCheckout";

const Checkout = (props) => {
  const { buttonName } = props;

  if (buttonName === "Upgrade") {
    return <ChangePlanCheckout {...props} />;
  }
  if (buttonName === "Downgrade") {
    return <ChangePlanCheckout {...props} />;
  }
  if (buttonName === "Get Started") {
    return <NewPlanCheckout {...props} />;
  }
  return <CurrentPlanCheckout {...props} />;
};

Checkout.propTypes = {
  authenticityToken: PropTypes.string.isRequired,
  buttonName: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  customFields: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  planClass: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  displayPrice: PropTypes.number.isRequired,
  publishableKey: PropTypes.string.isRequired,
  taxPercent: PropTypes.number.isRequired,
  changePlanId: PropTypes.string,
  changePlanPath: PropTypes.string,
};

Checkout.defaultProps = {
  changePlanId: PropTypes.isNull,
  changePlanPath: PropTypes.isNull,
};

export default Checkout;
